import { TYPE_CONFIG } from '../../constants';

export default function TypeSelectorButtons({ typeOptions, value, onChange, iconSize = 18, wrapperClass = 'type-selector' }) {
  return (
    <div className={wrapperClass}>
      {typeOptions.map((t) => {
        const config = TYPE_CONFIG[t.value];
        const Icon = config.icon;
        return (
          <button
            key={t.value}
            type="button"
            className={`type-option ${value === t.value ? 'active' : ''}`}
            style={value === t.value ? { borderColor: config.color, color: config.color } : {}}
            onClick={() => onChange(t.value)}
          >
            <Icon size={iconSize} /> {t.label}
          </button>
        );
      })}
    </div>
  );
}
